import * as Tooltip from '@radix-ui/react-tooltip';
import React from 'react';
import { VoiceOverviewTenantsTable } from './VoiceOverviewTenantsTable';
import { VoiceOverviewSummaryCards } from './VoiceOverviewSummaryCards';
import { useVoiceTenantOverviewSummary } from './useVoiceTenantOverview';
import styles from './VoiceOverviewTab.module.css';

export const VoiceOverviewTab: React.FC = () => {
  const summaryQuery = useVoiceTenantOverviewSummary();
  const summary = summaryQuery.data;

  const summaryFailed = summaryQuery.error !== null;
  const showSummaryPlaceholders = summaryQuery.isLoading;
  return (
    <Tooltip.Provider delayDuration={200}>
      <div className={styles.root}>
        <VoiceOverviewSummaryCards
          summary={summary}
          isLoading={showSummaryPlaceholders}
          isFailed={summaryFailed}
          isFetching={summaryQuery.isFetching}
        />
        <VoiceOverviewTenantsTable />
      </div>
    </Tooltip.Provider>
  );
};
